import { BiX } from "react-icons/bi";

function Modal({ isOpen, onClose, isFullScreen, children, className = '', contentStyle }) {
    if (!isOpen) return null;

    const contentClassName = [
        isFullScreen ? 'modal-content-fullscreen' : 'modal-content',
        className,
    ].filter(Boolean).join(' ');

    return (
        <div className="modal-overlay">
            <div className={contentClassName} style={contentStyle}>
                {onClose ? <div className="modal-close-button" style={{ cursor: 'pointer' }}>
                    <BiX
                        size={"1.2rem"}
                        onClick={onClose}
                    />
                </div> : <></>}


                {/* <button className="modal-close-button" onClick={onClose}>
                   &times; 
                </button> */}
                {children}
            </div>
        </div>
    );
}

export default Modal
